import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import * as mock from "../data/mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext(null);

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [cmsRes, prodRes, testiRes, payRes] = await Promise.all([
        axios.get(`${API}/cms`),
        axios.get(`${API}/products`),
        axios.get(`${API}/testimonials`),
        axios.get(`${API}/payments/config`).catch(() => ({ data: { online_enabled: false } })),
      ]);
      setData({ cms: cmsRes.data || {}, products: prodRes.data || [], testimonials: testiRes.data || [], paymentConfig: payRes.data });
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const cms = data?.cms || {};
  const product = (data?.products && data.products[0]) || mock.product;
  const testimonials = data?.testimonials?.length ? data.testimonials : mock.testimonials;

  const value = {
    loading,
    error,
    reload: load,
    product,
    variants: (product?.variants?.length ? product.variants : mock.variants),
    heroImages: mock.heroImages,
    urgency: cms.urgency?.text || mock.product && "YOUR FIRST 100 CRORES IS JUST A CALL AWAY",
    hero: cms.hero || {},
    video: cms.video || { youtubeId: mock.mainVideoId, kicker: "Watch The Video Below", title: "See Why Thousands Trust Adrusta Ratnam" },
    financial: cms.financial || { problems: mock.financialProblems },
    about: cms.about || mock.astrologer,
    whatYouGet: cms.whatYouGet || { title: "A Complete Spiritual Wealth System", items: mock.whatYouGet },
    trust: cms.trust?.badges || mock.trustBadges,
    countdown: cms.countdown || { enabled: true, kicker: "Why Time Is Of The Essence", title: "Limited Energised Pieces Remaining", subtitle: "Each Ratnam is hand-energised in small batches. Reserve yours before this window closes.", hours: 6 },
    showcase: cms.showcase || { kicker: "Certified & Energised", title: "Not Just a Ratnam — A Result-Driven Wealth Companion", showSpecs: true, benefits: [] },
    success: cms.success || { title: "Success Stories", shorts: mock.successStories },
    faqs: cms.faq?.items || mock.faqs,
    footer: cms.footer || mock.store,
    testimonials,
    telegramLink: cms.footer?.telegram || mock.telegramLink,
    callus: cms.callus || {},
    paymentConfig: data?.paymentConfig || { online_enabled: false },
  };

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};
